import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/calendar",
    name: "Calendar",
    meta: { title: "Koledar" },
    component: () => import(/* webpackChunkName: "Entities List" */ "@/Modules/Calendar/Views/Calendar"),
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "new",
        name: "New Event",
        meta: { title: "Nov vnos" }
      },
      {
        path: "event/:id",
        name: "Event Details"
      },
      {
        path: "event/:id/new-customer",
        name: "New Customer",
        meta: { title: "Nova stranka" }
      }
    ]
  }
]
